module.exports = __webpack_public_path__ + "static/img/logo.c35f293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/logo.png
// module id = R11p
// module chunks = 1